import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-load-more",
  "use": "icon-load-more-usage",
  "viewBox": "0 0 97 89",
  "content": "<symbol viewBox=\"0 0 97 89\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-load-more\">\n<path d=\"M87.68 44.34C87.68 68.2262 68.2262 87.68 44.34 87.68C20.4538 87.68 1 68.2262 1 44.34C1 20.4538 20.2075 1 44.34 1\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" />\n<path d=\"M78.8164 52.9591L87.6814 44.3404L96.3002 52.9591\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol